<template>
  <div class="m-pagination">
    <div class="m-pagination__container">
      <button class="m-pagination__btn" title="前往第一頁" @click="goFirst">
        First
      </button>
      <div class="m-pagination__btn" title="前往上一頁" aria-label="前往上一頁" @click="pre">
        <svg width="9" height="17">
          <title>前往上一頁</title>
          <path d="M.324 8.992l6.789 7.036a1.078 1.078 0 001.563 0 1.176 1.176 0 000-1.62L2.67 8.181l6.007-6.226a1.176 1.176 0 000-1.62 1.078 1.078 0 00-1.564 0L.324 7.372a1.164 1.164 0 00-.324.81c0 .293.108.586.324.81z" />
        </svg>
      </div>
      <button
        v-for="(i, index) in page"
        :key="index"
        :class="{ 'm-pagination__btn--active': i === innerCurrentPage }"
        :title="`前往第${i}頁`"
        class="m-pagination__btn"
        @click="goPage(i)"
      >
        {{ i }}
      </button>
      <button class="m-pagination__btn" title="前往下一頁" aria-label="前往下一頁" @click="next">
        <svg width="8" height="15">
          <title>前往下一頁</title>
          <path d="M7.712 8.243l-6.034 6.45a.938.938 0 01-1.39 0 1.102 1.102 0 010-1.486L5.628 7.5.287 1.793a1.102 1.102 0 010-1.485.939.939 0 011.39 0l6.034 6.45c.192.205.288.473.288.742s-.096.538-.288.743z" />
        </svg>
      </button>
      <button class="m-pagination__btn" title="前往第最後一頁" @click="goLast">
        Last
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Pagination',
  props: {
    totalPage: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      innerCurrentPage: this.currentPage,
      page: []
    }
  },
  computed: {
    ...mapGetters([
      'WIDTH_MOBILE',
      'screenWidth'
    ])
  },
  watch: {
    // 頁數有異動的時候重新產生分頁
    currentPage(val) {
      this.innerCurrentPage = val
      this.makePage(this.totalPage, val)
    },
    totalPage(val) {
      this.makePage(val, this.currentPage)
    }
  },
  mounted() {
    this.makePage(this.totalPage, this.currentPage)
  },
  methods: {
    makePage(total, cur, around = 2) {
      let result = []
      // 顯示的頁碼總數
      let baseCount = 5

      if (this.screenWidth < this.WIDTH_MOBILE) {
        baseCount = 3
        around = 1
      }

      const startPosition = around + 1
      const endPosition = total - around
      const surplus = baseCount

      if (total <= baseCount) {
        result = Array.from({ length: total }, (v, i) => i + 1)
      } else if (cur < startPosition) {
        result = [...Array.from({ length: surplus }, (v, i) => i + 1)]
      } else if (cur > endPosition) {
        result = [...Array.from({ length: surplus }, (v, i) => total - surplus + i + 1)]
      } else {
        result = [...Array.from({ length: around * 2 + 1 }, (v, i) => cur - around + i)]
      }
      this.page = result
    },
    pre() {
      if (this.currentPage > 1) {
        this.innerCurrentPage -= 1
        this.$emit('update', this.currentPage - 1)
        this.makePage(this.totalPage, this.currentPage - 1)
        this.pushQuery()
      }
    },
    next() {
      if (this.currentPage < this.totalPage) {
        this.innerCurrentPage += 1
        this.$emit('update', this.currentPage + 1)
        this.makePage(this.totalPage, this.currentPage + 1)
        this.pushQuery()
      }
    },
    goPage(num) {
      this.innerCurrentPage = num
      this.$emit('update', num)
      this.makePage(this.totalPage, num)
      this.pushQuery()
    },
    goFirst() {
      this.innerCurrentPage = 1
      this.$emit('update', 1)
      this.makePage(this.totalPage, 1)
      this.pushQuery()
    },
    goLast() {
      this.innerCurrentPage = this.totalPage
      this.$emit('update', this.totalPage)
      this.makePage(this.totalPage, this.totalPage)
      this.pushQuery()
    },
    pushQuery() {
      // 因為搜尋頁會進行路由跳轉，所以就只更改 page 的數值不跳轉
      // if (this.$route.path.includes('/search/') || this.$route.path === '/author') {
      //   this.$route.query.page = this.innerCurrentPage
      //   return
      // }
      this.$router.push({
        path: this.$route.path,
        query: {
          page: this.innerCurrentPage,
          ...(this.$route.query.category ? { category: this.$route.query.category } : {})
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '~/assets/scss/modules/_pagination';
</style>
